module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticClass: "fontHead",
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        showBack: false
      },
      "right-options": {
        showMore: true
      }
    }
  }, [_c('router-link', {
    staticClass: "Main_left",
    attrs: {
      "slot": "left",
      "to": "/main"
    },
    slot: "left"
  }, [_vm._v(" 我的")]), _vm._v("\n\t\t\t财务管理\n\t\t")], 1), _vm._v(" "), _c('div', {
    staticClass: "user-balance"
  }, [_c('div', {
    staticClass: "balance-box"
  }, [_c('p', {
    staticClass: "bal_money"
  }, [_vm._v(_vm._s(_vm.money.split('.')[0]) + "."), _c('span', [_vm._v(_vm._s(_vm.money.split('.')[1]))])]), _vm._v(" "), _c('p', {
    staticClass: "detxt"
  }, [_vm._v("账户可用余额（元）")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/user/payment"
    }
  }, [_vm._v("充值")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group-list"
  }, [_c('div', {
    staticClass: "mui-page-content"
  }, [_c('ul', {
    staticClass: "form-group"
  }, [_c('li', {
    staticClass: "mui-table-view-cell"
  }, [_c('router-link', {
    attrs: {
      "to": "/user/payment"
    }
  }, [_vm._v("充值中心")])], 1), _vm._v(" "), _c('li', {
    staticClass: "mui-table-view-cell"
  }, [_c('router-link', {
    attrs: {
      "to": "/user/money"
    }
  }, [_vm._v("收支细节")])], 1), _vm._v(" "), _c('li', {
    staticClass: "mui-table-view-cell"
  }, [_c('router-link', {
    attrs: {
      "to": "/user/cashcoupon"
    }
  }, [_vm._v("优惠券")])], 1)])])]), _vm._v(" "), _c('c-footer', {
    attrs: {
      "status": "product"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14e86780","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/finance/catalog.vue
// module id = nMSw
// module chunks = 1